import { Dropdown, Form, Input } from "antd";
import { useState } from "react";
import { search_proveedores_by_name_or_code } from "../../../../actions/proveedor";

export const ProveedorDropdown = ({
  name,
  nameSearchText,
  label = " ",
  ...restProps
}) => {
  console.log(nameSearchText);
  const form = Form.useFormInstance();
  const [items, setItems] = useState([]);
  const [itemsData, setItemsData] = useState([]);
  const handleSearch = async (value, event) => {
    event.preventDefault();
    if (value?.length > 0) {
      const data = await search_proveedores_by_name_or_code(value);
      const options = data.map((item) => ({
        label: item?.label,
        key: item?.value,
      }));
      setItems(options);
      setItemsData(data);
    }
  };
  const onClick = ({ key }) => {
    const itemSelect = itemsData?.find((x) => x.value === parseInt(key));
    console.log(itemSelect);
    form.setFieldValue(name, itemSelect?.value);
    form.setFieldValue(nameSearchText, itemSelect?.label);
  };
  const handleChangeSearch = () => {
    form.setFieldValue(name, null);
  };
  return (
    <Dropdown menu={{ items, onClick }}>
      <Form.Item name={nameSearchText} label={label}>
        <Input.Search
          placeholder={restProps?.placeholder}
          allowClear
          enterButton
          onSearch={handleSearch}
          onChange={handleChangeSearch}
          disabled={restProps?.disabled || false}
        />
      </Form.Item>
    </Dropdown>
  );
};
